import { registerEnumSet } from '@if/mui'
import { EInvitationDeliveryStatus } from '@src/types/InvitationHistoryDto'
import { ECommunicationType } from '@src/types/InvitationSchema'
import { CircleCheck, CircleX, Clock, Mail, MessageSquare, Send } from 'lucide-react'

// The two invitation-history chips (channel and delivery status), so the grid renders them through
// `type: 'enumChip'` like every other status surface. Load-once side-effect - imported at bootstrap.
registerEnumSet(ECommunicationType, {
  [ECommunicationType.Email]: { color: 'info', icon: Mail, labelKey: 'invitationDialog.email' },
  [ECommunicationType.SMS]: { color: 'info', icon: MessageSquare, labelKey: 'invitationDialog.sms' },
  [ECommunicationType.Both]: { color: 'info', icon: Send, labelKey: 'invitationDialog.emailAndSms' },
})

// Sent is not a delivery confirmation: it means the provider accepted the message. Only a callback
// from the provider moves a row to delivered or failed, and email keeps waiting on the SendGrid event
// webhook - so pending is a legitimate resting state, not a stuck one.
registerEnumSet(EInvitationDeliveryStatus, {
  [EInvitationDeliveryStatus.Pending]: { color: 'warning', icon: Clock, labelKey: 'invitationHistory.status.pending' },
  [EInvitationDeliveryStatus.Sent]: { color: 'info', icon: Send, labelKey: 'invitationHistory.status.sent' },
  [EInvitationDeliveryStatus.Delivered]: {
    color: 'success',
    icon: CircleCheck,
    labelKey: 'invitationHistory.status.delivered',
  },
  [EInvitationDeliveryStatus.Failed]: { color: 'error', icon: CircleX, labelKey: 'invitationHistory.status.failed' },
})
